import React from "react";
import { Link } from "react-router-dom";
import {
  FaFingerprint,
  FaMoneyBillWave,
  FaBuilding,
  FaIdCard,
  FaBolt,
  FaArrowRight,
} from "react-icons/fa";

const CoreServices = () => {
  const services = [
    {
      id: 1,
      icon: <FaFingerprint />,
      title: "AEPS",
      description:
        "Aadhaar-enabled cash withdrawals, balance inquiries, and mini statements.",
      link: "/services#aeps",
    },
    {
      id: 2,
      icon: <FaMoneyBillWave />,
      title: "DMT",
      description:
        "Instant domestic money transfer to any bank account across India.",
      link: "/services#dmt",
    },
    {
      id: 3,
      icon: <FaBuilding />,
      title: "CMS",
      description:
        "Cash management services for businesses – collection & settlement.",
      link: "/services#cms",
    },
    {
      id: 4,
      icon: <FaIdCard />,
      title: "PAN Card",
      description:
        "Instant PAN card issuance and e-PAN services for your customers.",
      link: "/services#pan",
    },
    {
      id: 5,
      icon: <FaBolt />,
      title: "Mobile & DTH Recharge",
      description:
        "Recharge mobile phones and DTH services instantly through our platform.",
      link: "/services#bills",
    },
    {
      id: 5,
      icon: <FaBolt />,
      title: "Utility Bill Payments",
      description:
        "Electricity, water, gas, DTH, and mobile recharge – all in one dashboard.",
      link: "/services#bills",
    },
  ];

  return (
    <section style={styles.section}>
      <div className="container" style={styles.container}>
        {/* Section Header */}
        <div style={styles.header}>
          <span style={styles.subtitle}>What We Offer</span>
          <h2 style={styles.title}>
            Core Financial Services for{" "}
            <span style={styles.accent}>Your Business</span>
          </h2>
          <p style={styles.description}>
            Empower your retail shop with our comprehensive suite of digital
            financial products.
          </p>
        </div>

        {/* Services Grid */}
        <div style={styles.grid}>
          {services.map((service) => (
            <div key={service.id} style={styles.card}>
              <div style={styles.iconWrapper}>{service.icon}</div>
              <h3 style={styles.cardTitle}>{service.title}</h3>
              <p style={styles.cardDesc}>{service.description}</p>
              {/* <Link to={service.link} style={styles.cardLink}>
                Learn More <FaArrowRight style={styles.arrowIcon} />
              </Link> */}
            </div>
          ))}
        </div>

        {/* View All Button */}
        {/* <div style={styles.buttonWrapper}>
          <Link to="/services" style={styles.button}>
            View All Services
          </Link>
        </div> */}
      </div>
    </section>
  );
};

// Inline styles – you can move these to a CSS file
const styles = {
  section: {
    backgroundColor: "#ffffff",
    padding: "80px 0",
    fontFamily: "'Inter', sans-serif",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
  },
  header: {
    textAlign: "center",
    marginBottom: "60px",
  },
  subtitle: {
    display: "inline-block",
    backgroundColor: "#f39c1220",
    color: "#f39c12",
    fontWeight: "600",
    fontSize: "0.9rem",
    padding: "4px 16px",
    borderRadius: "30px",
    marginBottom: "16px",
  },
  title: {
    fontSize: "clamp(2rem, 4vw, 2.8rem)",
    fontWeight: "700",
    color: "#1e293b",
    marginBottom: "16px",
    lineHeight: "1.2",
  },
  accent: {
    color: "#f39c12",
  },
  description: {
    fontSize: "1.1rem",
    color: "#64748b",
    maxWidth: "600px",
    margin: "0 auto",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "30px",
    marginBottom: "50px",
  },
  card: {
    backgroundColor: "#f9fafc",
    borderRadius: "16px",
    padding: "30px 20px",
    textAlign: "center",
    transition: "all 0.3s ease",
    border: "1px solid #eef2f6",
    cursor: "default",
  },
  // Hover effect – will be handled via CSS class or inline style with :hover not possible; we can use a CSS file or styled-components.
  // For now, we'll include a style object and mention that hover styles should be added in CSS.
  // In a real project, you'd use CSS modules or styled-components.
  cardHover: {
    transform: "translateY(-5px)",
    boxShadow: "0 20px 30px rgba(0,0,0,0.05)",
    borderColor: "#f39c1240",
  },
  iconWrapper: {
    width: "70px",
    height: "70px",
    margin: "0 auto 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
    borderRadius: "50%",
    boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
    color: "#f39c12",
    fontSize: "2rem",
  },
  cardTitle: {
    fontSize: "1.4rem",
    fontWeight: "600",
    color: "#1e293b",
    marginBottom: "12px",
  },
  cardDesc: {
    fontSize: "0.95rem",
    color: "#64748b",
    lineHeight: "1.6",
    marginBottom: "20px",
  },
  cardLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    color: "#f39c12",
    fontWeight: "500",
    textDecoration: "none",
    transition: "gap 0.2s ease",
  },
  arrowIcon: {
    fontSize: "0.8rem",
    transition: "transform 0.2s ease",
  },
  buttonWrapper: {
    textAlign: "center",
  },
  button: {
    display: "inline-block",
    backgroundColor: "transparent",
    border: "2px solid #f39c12",
    color: "#f39c12",
    fontWeight: "600",
    padding: "12px 36px",
    borderRadius: "50px",
    textDecoration: "none",
    fontSize: "1rem",
    transition: "all 0.3s ease",
  },
};

// Note: Hover effects for cards and links need to be implemented via CSS.
// You can add a CSS file with the following:
/*
  .core-service-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 30px rgba(0,0,0,0.05);
    border-color: #f39c1240;
  }
  .core-service-card:hover .core-service-icon {
    background-color: #f39c12;
    color: #ffffff;
  }
  .core-service-link:hover {
    gap: 10px;
  }
  .core-service-link:hover .arrow-icon {
    transform: translateX(4px);
  }
  .core-service-button:hover {
    background-color: #f39c12;
    color: #1e293b;
  }
*/

export default CoreServices;
